import { Star } from 'lucide-react';

export function StarRating({ rating = 0, size = 16, showNumber = false }) {
  const rounded = Math.round(rating);
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map(star => (
        <Star
          key={star}
          size={size}
          className={star <= rounded ? 'text-amber-400 fill-amber-400' : 'text-gray-200 fill-gray-200'}
        />
      ))}
      {showNumber && <span className="text-sm text-gray-500 ml-1">{Number(rating).toFixed(1)}</span>}
    </div>
  );
}
